module.exports = __webpack_public_path__ + "static/media/media.605f8f98.jpg";